import { defineComponent as _defineComponent } from 'vue'
import ProposalGovernance from "@/components/governance/ProposalGovernance.vue";
import {onActivated, onBeforeMount, onDeactivated, onUnmounted} from "vue";
import {useProposalsStore} from "@/store/proposals.store";
import dataService from "@/services/data.service";


const __default__ = {
  name: 'ProposalsList',
  inheritAttrs: false,
  customOptions: {}
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();


onActivated(() => {
 window.addEventListener('scroll', load);
});

onDeactivated(() => {
 window.removeEventListener('scroll', load);
});

onBeforeMount(()=> {
  dataService.onGovernanceSelected();
});

onUnmounted(() => {
  dataService.onGovernanceUnselected();
});

const load = () => {
 let bottomOfWindow = Math.abs(Math.ceil(document.documentElement.scrollTop) + window.innerHeight - document.documentElement.offsetHeight) < 2;
 if (bottomOfWindow) {
    dataService.onGovernanceScroll();
 }
};


const __returned__ = { load, ProposalGovernance, get useProposalsStore() { return useProposalsStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})